import { useState } from "react";

const FAQ_ITEMS = [
  {
    q: "Do I need any technical knowledge to manage my store?",
    a: "No. We build everything and hand it over in a simple, easy-to-use format. Adding products or changing prices takes less than 2 minutes. We also provide a short walkthrough video after launch.",
  },
  {
    q: "What does Shopify charge per month?",
    a: "Shopify's Basic plan is approximately ₹2,000/month, billed directly to you by Shopify. Our setup fee is a separate, one-time charge. We help you set up your Shopify account as part of our process.",
  },
  {
    q: "Will my store work on mobile phones?",
    a: "Yes. Every store we build is mobile-first. Over 80% of online shoppers in India browse and buy on their phones.",
  },
  {
    q: "Can I keep using WhatsApp and Instagram alongside the store?",
    a: "Absolutely. Most of our clients continue using Instagram to drive traffic - the store simply gives their followers a fast, professional way to place orders and pay, instead of going back and forth over DM.",
  },
  {
    q: "What if I want changes after the store is live?",
    a: "Minor updates within the first week of launch are included. For ongoing changes, we offer a monthly maintenance retainer starting at ₹3,000/month.",
  },
  {
    q: "How do I receive payments from customers?",
    a: "We integrate UPI, debit/credit cards and net banking via Razorpay or Cashfree. Payments go directly into your bank account.",
  },
  {
    q: "I'm based in [city] - can you still build my store?",
    a: "Yes. We work with businesses across Maharashtra and South India entirely online. The entire process happens over WhatsApp and email - no in-person meetings needed.",
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(-1);
  const left = FAQ_ITEMS.slice(0, 4);
  const right = FAQ_ITEMS.slice(4);

  const renderAccordionColumn = (items, offset) =>
    items.map((item, idx) => {
      const absoluteIndex = offset + idx;
      const isOpen = openIndex === absoluteIndex;

      return (
        <div className="accordion" key={item.q}>
          <div className="accordion-title">
            <a
              href="#faq"
              className={isOpen ? "active" : ""}
              onClick={(event) => {
                event.preventDefault();
                setOpenIndex((prev) => (prev === absoluteIndex ? -1 : absoluteIndex));
              }}
            >
              {item.q}
            </a>
          </div>
          {isOpen ? <div className="accordion-content">{item.a}</div> : null}
        </div>
      );
    });

  return (
    <section id="faq" className="section-padding gray-bg">
      <div className="container text-center">
        <h2>
          Frequently Asked <span className="text-light">Questions</span>
        </h2>
        <p className="lead" style={{ maxWidth: "760px", margin: "12px auto 45px" }}>
          Everything you need to know before we start building your online store.
        </p>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-6">{renderAccordionColumn(left, 0)}</div>
          <div className="col-md-6">{renderAccordionColumn(right, 4)}</div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
